import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService} from '@app/core';
import { finalize } from 'rxjs/operators';
import { LOCAL_VAR } from '@app/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DealHelpComponent } from '@app/shared/modals/deal-help/deal-help.component';
import { DealsService } from '@app/core/service/deals.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-cancel-contact',
  templateUrl: './cancel-contact.component.html',
  styleUrls: ['./cancel-contact.component.scss']
})
export class CancelContactComponent implements OnInit {
  @ViewChild('goto') nameInput: ElementRef;
  loggedInUserType: any = null;
  user: Authentication.User;
  cancelformList: any;
  fiterForm: FormGroup;
  isLoading = false;
  perPage = 10;
  sortDir = -1;
  currentPage = 1;
  sortBy = 'createdAt';
  pager = {
    perPage: 10,
    currentPage: 1,
    Totalrecords: 0,
    TotalPages: 0
  };
  PageList: any;
  timer: any;
  statusTypes = [
    { text: 'Step1 Completed', value: 'step1 completed' },
    { text: 'Proforma Generated', value: 'proforma generated' },
    { text: 'Agreement Generated', value: 'agreement generated' },
    { text: 'Agreement Pending', value: 'agreement pending' },
    { text: 'Approved', value: 'approved' },
    { text: 'Rejected', value: 'rejected' }
  ];

  currentStatus='';

  constructor(
    private modalService: NgbModal,
    public utilService: UtilService,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private _service: DealsService
  ) {
    this.user = this.authenticationService.credentials.user;
    // console.log(this.user)
    this.loggedInUserType = this.user.userRoleId.slug;
    localStorage.setItem(LOCAL_VAR.selectedAgency, null);
    this.createForm();
    this.getListByFilter();
  }

  ngOnInit() {}



  createForm() {
    this.fiterForm = this.formBuilder.group({
      dealerName: [''],
      dealerNumber: [''],
      date_from: [],
      date_to: [''],
      perPage: 10
    });

    this.fiterForm.valueChanges.subscribe(values => {
      //this.pager.currentPage = 1;
      //this.getListByFilter();
      const self = this;
      clearInterval(self.timer);
      self.timer = setInterval(() => {
        clearInterval(self.timer);
        self.getListByFilter();
      }, 500);
    });
  }

  getListByFilter() {
    let payload = this.getPayload();
    payload = this.utilService.removeEmpty(payload);
        if (payload.date_from) {
          payload.from = DateTime.fromObject(payload.date_from).toISO();
        }
    
        if (payload.date_to) {
          payload.to = new Date(
            new Date(DateTime.fromObject(payload.date_to).toISO()).setHours(
              23,
              59,
              59
            )
          );
        }
    
        delete payload.date_from;
        delete payload.date_to;
    this.pager.perPage = payload.perPage;
    delete payload.perPage;
    this.getList(this.pager.currentPage, payload);
  }

  getList(page: number, payload: any) {
    payload.currentPage = page;
    payload.perPage = this.pager.perPage;
    this.isLoading = true;
    this._service
      .getCancelContactByFilter(payload)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        if (response.records) {
          this.cancelformList = response.records;
          this.renderPagination(
            response.page,
            response.total,
            response.totalPage
          );
        }
      },
      (error: any) => {
        console.log('Deal list error:', error);
        this.isLoading = false;
      });
  }

  goPage() {
    const goto = this.nameInput.nativeElement.value;
    this.setPage(goto);
    this.nameInput.nativeElement.value = '';
  }

  setPage(page: any) {
    if (
      0 < page &&
      page <= this.pager.TotalPages &&
      page != this.pager.currentPage
    ) {
      this.pager.currentPage = page;
      this.getListByFilter();
    }
  }

  renderPagination(page: number, total: number, totalPage: number) {
    this.pager.currentPage = page;
    this.pager.Totalrecords = total;
    this.pager.TotalPages = totalPage;
    this.PageList = this.utilService.getPageList(
      this.pager.TotalPages,
      this.pager.currentPage
    );
  }

  getPayload() {
    let payload = JSON.parse(JSON.stringify(this.fiterForm.value));
    payload = this.utilService.removeEmpty(payload);
    return payload;
  }

  omit_special_char(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k <= 122) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  omit_special_Mailchar(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k <= 122) ||
      k === 46 ||
      k === 64 ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  async openHelpPopup() {
    const modalRef = await this.modalService.open(DealHelpComponent);
  }
}

